import { reactive, computed } from 'vue'
import { defineStore } from 'pinia'
import NetworkService from '@/services/network-service';

export const appStore = defineStore('app', () => {
  const state = reactive({
    isLoading: false,
    axiosInstance: NetworkService
  })

  const isLoading = computed(() => state.isLoading);
  const setLoading = (val) => {
    state.isLoading = val;
  }

  const axi = computed(() => state.axiosInstance);
  const setToken = (token)  => {
    if (token) {
      state.axiosInstance.configuration.headers.Authorization = `Bearer ${token}`
    } else if (state.axiosInstance.configuration.headers.Authorization) {
      delete state.axiosInstance.configuration.headers.Authorization;
    }
  }

  return { 
    isLoading, setLoading, 
    axi, setToken
  }
});
